import { render, staticRenderFns } from "./BlockedCartForm.vue?vue&type=template&id=c93fc95e&scoped=true&"
import script from "./BlockedCartForm.vue?vue&type=script&lang=ts&"
export * from "./BlockedCartForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93fc95e",
  null
  
)

export default component.exports